import styled from 'styled-components'

import colors from '@settings/styleSettings'
import { hexToRgbA } from '@util/stringUtil'

export const CheckMarkIcon = styled.div`
  color: ${colors.titleStrongWhite};
  width: 24px;
  height: 24px;
`

export const SelectAllIcon = styled.div`
  color: ${colors.titleStrongWhite};
  width: 24px;
  height: 24px;
`

export const DashMarkIcon = styled.div`
  color: ${colors.titleStrongWhite};
  width: 24px;
  height: 24px;
`

export const CheckBoxLabel = styled.label`
  color: ${(props) => (props.state ? colors.titleStrongWhite : colors.strongGray)};
`

export const LabelSpan = styled.span`
  margin-left: 10px;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const StyledCheckbox = styled.div`
  cursor: pointer;
  display: inline-block;
  width: 24px;
  height: 24px;
  background: ${(props) => props.background};
  border: ${({ state }) => (state ? 'none' : `2.5px solid ${colors.softGray}`)};
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${hexToRgbA(colors.primary, 0.2)};
  }
  ${CheckMarkIcon} {
    visibility: ${({ checked, locked }) => (checked || locked ? 'visible' : 'hidden')};
  }
  border-radius: 3px;
  transition: all 150ms;
`

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
